import { apiFetch } from './apiClient';



/* ——— Etapas Padrão ——— */

export async function listarEtapasPadrao() {
  return apiFetch('/etapas-padrao');
}

export async function criarEtapaPadrao(titulo) {
  return apiFetch('/etapas-padrao', {
    method: 'POST',
    body: JSON.stringify({ titulo }),
  });
}

export async function excluirEtapaPadrao(id) {
  return apiFetch(`/etapas-padrao/${id}`, { method: 'DELETE' });
}

/* ——— Processos dentro de uma etapa padrão ——— */

export async function criarProcessoPadrao(etapaId, titulo) {
  return apiFetch(`/etapas-padrao/${etapaId}/processos`, {
    method: 'POST',
    body: JSON.stringify({ titulo }),
  });
}

export async function excluirProcessoPadrao(processoId) {
  return apiFetch(`/etapas-padrao/processos/${processoId}`, { method: 'DELETE' });
}

export async function atualizarProcessoPadrao(processoId, dados) {
  return apiFetch(`/etapas-padrao/processos/${processoId}`, {
    method: 'PATCH',
    body: JSON.stringify(dados),
  });
}

export async function atualizarEtapa(etapaId, dados) {
  return apiFetch(`/etapas-padrao/${etapaId}`, {
    method: 'PATCH',
    body: JSON.stringify(dados),
  });
}

/* ——— Processos do onboard por lead ——— */

export async function listarProcessosOnboard(leadId) {
  return apiFetch(`/onboard/leads/${leadId}/processos`);
}

export async function vincularEtapa(leadId, etapaPadraoId) {
  return apiFetch(`/onboard/leads/${leadId}/vincular`, {
    method: 'POST',
    body: JSON.stringify({ etapa_padrao_id: etapaPadraoId }),
  });
}

export async function adicionarProcesso(leadId, titulo) {
  return apiFetch(`/onboard/leads/${leadId}/processos`, {
    method: 'POST',
    body: JSON.stringify({ titulo }),
  });
}

export async function toggleProcesso(processoId) {
  return apiFetch(`/onboard/processos/${processoId}/toggle`, { method: 'PATCH' });
}

export async function removerProcesso(processoId) {
  return apiFetch(`/onboard/processos/${processoId}`, { method: 'DELETE' });
}

/* ——— Registros de processo ——— */

export async function salvarRegistro(leadId, dados) {
  return apiFetch(`/onboard/leads/${leadId}/registros`, {
    method: 'POST',
    body: JSON.stringify(dados),
  });
}

export async function listarRegistros(leadId) {
  return apiFetch(`/onboard/leads/${leadId}/registros`);
}

export async function atualizarRegistro(id, dados) {
  return apiFetch(`/onboard/registros/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(dados),
  });
}

export async function salvarAnexoProcesso(processoId, { anexo_url, anexo_nome }) {
  return apiFetch(`/onboard/processos/${processoId}/anexo`, {
    method: 'PATCH',
    body: JSON.stringify({ anexo_url, anexo_nome }),
  });
}
